export class AppConstants {
    //routes
    public static ADMIN_PAGE: string = "admin-page"
    public static DASHBOARD_ROUTE: string = "dashboard";
    public static PATH_NON_CONFORMITA_POSIZIONE: string = "/nonConformita/nonConfPosizione";
    public static ORDINI_ROUTE: string = "ordini";
    public static DOCUMENTS_ROUTE: string = "documenti";
    public static CESTINO_ROUTE: string = "cestino";
    public static SVINCOLI_ROUTE: string = "svincoli";
    public static UTENTE_NON_ABILITATO_ROUTE: string = "userNotValid";
    public static FASI_ROUTE: string = "fasi";
    public static NOTIFICHE_ROUTE: string = "notifiche";
    public static NONCONFORMITA_ROUTE: string = "non-conformita";
    public static ARCHIVI_ROUTE: string = "archivi";
    public static PREVIEW_DOCUMENTO_ROUTE: string = "previewDocumento";
    public static ISPEZIONI_ROUTE: string = "ispezioni";
    public static UPLOAD_DOCUMENTI_ROUTE: string = "upload-documenti"

    //ordini
    public static ORDINI_PER_PAGINA: number = 10;
    public static NON_CONFORMITA_PER_PAGINA: number = 10

    //fasi obbligatorie
    public static MANDATORY_PHASES = ["DOC_CONTRATTUALE", "COLLAUDO_FINALE", "FINAL_DATA_BOOK", "CERTIFICAZIONE_DOC_FINALE"];

    //DASHBOARD
    public static DASHBOARD_FIRST: number = 0;
    public static DASHBOARD_ORDINI_LENGHT: number = 5;
    public static DASHBOARD_DCOUMENTI_LENGHT: number = 6;

    //ms-svincoli
    public static SVINCOLI_PER_PAGINA: number = 10;
    public static MATRICOLE_PER_PAGINA: number = 10;
    public static PATH_SVINCOLI: string = "/svincoli";
    public static PATH_TOTALE_SVINCOLI: string = "/svincoli/count";
    public static PATH_CAMBIA_STATO: string = "/cambioStato";
    public static PATH_GET_EXCEL_TEMPLATE: string = "/svincoli/getExcelTemplate";
    public static PATH_UPLOAD_EXCEL_TEMPLATE: string = "/svincoli/getExcelTemplate";
    public static PATH_IS_SVINCOLI_APERTI: string = "/svincoli/isSvincoloApertoSuPosizione";
    public static PATH_CREATE_SVINCOLO: string = "/svincoli/svincolo";
    public static PATH_QUANTITA_SVINCOLATA: string = "/svincoli/quantitaSvincolataPerPosizione"
    public static PATH_UPLOAD_EXCEL: string = "/svincoli/uploadExcelMatricole"
    public static PATH_GET_QUANTITA_MATRICOLE: string = "/svincoli/getQuantitaDaMatricole"
    public static PATH_GET_MATRICOLE: string = "/matricole"
    public static PATH_TOTALE_MATRICOLE: string = "/matricole/count"
    public static PATH_EXCEL_MATRICOLE: string = "/getMatricoleExcel"
    public static PATH_EXCEL_SVINCOLI: string = "/svincoli/getExcel"

    //ms-utenti path
    public static PATH_UTENTE: string = "/utente";
    public static PATH_UTENTI: string = "/utenti";
    public static PATH_SET_UTENTI_ORDINE: string = "/setUtentiOrdine";
    public static PATH_SET_UTENTI_ORDINE_MASSIVO: string = "/setUtentiOrdiniMassivo";
    public static PATH_SET_ISPETTORE_SNAM: string = "/setIspettoreSnam";

    //ms-ordini path
    public static PATH_ORDINI: string = "/ordini";
    public static PATH_POSIZIONI: string = "/posizioni";
    public static PATH_FASI: string = "/fasi";
    public static PATH_FASI_POSIZIONE: string = "/fasi/getFasiPosizione";
    public static PATH_TOTALE_ORDINI: string = "/ordini/count";
    public static PATH_EVADI_POSIZIONE: string = "/evadi";
    public static PATH_PROGRESSO_FASE : string = "/setProgresso"
    public static PATH_GET_LIST_FASI_BY_NUMERO_ORDINE : string = "/ordini/getFasiStandard"
    public static PATH_SET_HASHTAG: string = "/hashtag";
    public static PATH_EXCEL_ORDINI: string = "/ordini/getExcel";

    //ms-documenti path
    public static DOCUMENTI_PER_PAGINA: number = 10;
    public static PATH_DOCUMENTI: string = "/documenti";
    public static PATH_TOTALE_DOCUMENTI: string = "/documenti/count";
    public static PATH_DOWNLOAD_DOCUMENTO_AS_PREVIEW: string = "/documenti/{0}/previewDocumento";
    public static PATH_DOWNLOAD_DOCUMENTO_AS_ATTACHMENT: string = "/documenti/{0}/downloadAsAttachment";
    public static PATH_DELETE_DOCUMENTO: string = "/documenti/";
    public static PATH_RENAME_DOCUMENTO: string = "/renameDocument";
    public static PATH_DOCUMENTI_PER_NC: string = "/documenti/nonConformita";
    public static PATH_ARCHIVI: string = "/archivi";
    public static PATH_DOWNLOAD_ARCHIVIO: string = "/archivi/{0}";
    public static PATH_GENERA_ARCHIVI: string = "/archivi/posizione";

    //ms-fornitori path
    public static PATH_FORNITORI: string = "/fornitori";
    public static PATH_PARTITE: string = "/getPartite";
    public static PATH_ALL_FORNITORI: string = "/getAllFornitori";

    //ms-notifiche path
    public static PATH_NOTIFICHE: string = "/notifiche";
    public static PATH_COUNT_NOTIFICHE: string = "/notifiche/count";
    public static NOTIFICHE_PER_PAGINA: number = 10;

    //ms-collaudi path
    public static ISPEZIONI_PER_PAGINA: number = 10;
    public static ISPEZIONI_COUNT: string = "/collaudi/count";
    public static ISPEZIONI: string = "/collaudi";
    public static RIMUOVI_ISPEZIONI: string = "/deleteIspezioni";
    public static PATH_EXCEL_ISPEZIONI: string = "/collaudi/getExcel"

    //ms-non-conformita-path
    public static PATH_NON_CONFORMITA: string = "/nonConformita"
    public static PATH_NON_CONFORMITA_ORDRINE: string = "/nonConformita/nonConfOrdine"
    public static PATH_COUNT_NONCONFORMITA: string = "/nonConformita/count"
    public static PATH_CREATE_NON_CONFORMITA: string = "/nonConformita"
    public static PATH_NON_CONFORMITA_CAMBIO_STATO: string = "/cambioStato"
    public static PATH_EXECL_NON_CONFORMITA: string = "/nonConformita/getExcel"

}
